module.exports = __webpack_public_path__ + "static/media/logo_nodots.83162b83.svg";